import {
  BasicResponsiveImage,
  Callout,
  PromoCode,
  StandardTile,
  StandardTileContents,
  StandardTileDescription,
  StandardTileImage,
  StandardTileName,
  StandardTileOverlay,
  StandardTilePromoCode,
  StandardTilePromoCodeLabel,
} from '@vp/swan'
import { TILE_ROW_SCHEMA } from '../../utils/trackingSchemas'
import { createOnClickTrackingHandler } from '../../Analytics/trackingUtils'
import { CampaignCallout } from '@vp/campaign-callouts'
import { useLogger } from '@vp/ubik-context'
import { type TrackingLinkConfig, type MapTrackingConfig } from '../../shared/types'

interface TileData {
  calloutText?: string
  calloutColor?: string
  calloutVariant?: string
  promoCode?: string
  transformedUrl: { url: string }
  productImage: { cloudinaryImage: { transformedCloudinaryUrl: string } }
  productTileSubHeader?: string
  productTileHeader?: string
  mpv?: { mpvId: string; productName?: string }
}

const Tile = ({
  data,
  trackingConfiguration,
  promoCodeText,
  loadType,
  usesMap,
  mapMetadata,
}: {
  data: TileData
  trackingConfiguration: TrackingLinkConfig | undefined
  promoCodeText: string
  loadType: string
  usesMap: boolean
  mapMetadata: MapTrackingConfig | undefined
}) => {
  const { calloutText, calloutColor, calloutVariant, promoCode, transformedUrl, productImage, productTileSubHeader, productTileHeader, mpv } = data
  const linkTrackingAttributes = trackingConfiguration ? trackingConfiguration.linkAttributes : {}
  const logger = useLogger()

  return (
    <StandardTile
      component="a"
      marginBottom={0}
      onClick={createOnClickTrackingHandler({
        trackingConfig: trackingConfiguration,
        logger,
        schema: TILE_ROW_SCHEMA,
        href: transformedUrl.url,
        openLinkNewTab: undefined,
        callback: undefined,
        mapTrackingConfig: usesMap ? mapMetadata : undefined,
        mapSchema: undefined,
      })}
      {...linkTrackingAttributes}
      href={transformedUrl.url}
    >
      <StandardTileOverlay>
        {calloutText && (
          <>
            <Callout skin={calloutColor} emphasis={calloutVariant} className="snowflake-callout">
              {calloutText}
            </Callout>
          </>
        )}
        <CampaignCallout product={mpv?.mpvId ?? ''} />
      </StandardTileOverlay>
      <StandardTileImage>
        <BasicResponsiveImage aspectRatio={1} src={productImage.cloudinaryImage.transformedCloudinaryUrl} alt="" loading={loadType} />
      </StandardTileImage>
      <StandardTileContents paddingBottom={4}>
        <StandardTileName>{productTileHeader ?? mpv?.productName}</StandardTileName>
        {productTileSubHeader && <StandardTileDescription>{productTileSubHeader}</StandardTileDescription>}
        {promoCode && promoCode.trim() !== '' && (
          <StandardTilePromoCode>
            <StandardTilePromoCodeLabel>{promoCodeText}</StandardTilePromoCodeLabel>
            <PromoCode>{promoCode}</PromoCode>
          </StandardTilePromoCode>
        )}
      </StandardTileContents>
    </StandardTile>
  )
}

export default Tile
